module.exports = __webpack_public_path__ + "img/logo-menu.b90b9270.png";